@if (agreementMetadata?.length) {
  <h3 class="card-title">{{ 'agreement.agreementMetadata' | translate }}</h3>
  <div class="metadata property">
    <div class="metadata-grid">
      <ng-container *ngFor="let data of agreementMetadata">
        <div class="meta-grid-key">{{ data.key }}</div>
        <div class="meta-grid-value">{{ data.value }}</div>
      </ng-container>
    </div>
  </div>
}
@if (subscriberMetadata?.length) {
  <h3 class="card-title">{{ 'agreement.subscriberMetadata' | translate }}</h3>
  <div class="metadata property">
    <div class="metadata-grid">
      <ng-container *ngFor="let data of subscriberMetadata">
        <div class="meta-grid-key">{{ data.key }}</div>
        <div class="meta-grid-value">{{ data.value }}</div>
      </ng-container>
    </div>
  </div>
}
@if (sessionMetadata.length) {
  <h3 class="card-title">{{ 'agreement.sessionMetadata' | translate }}</h3>
  <div class="metadata property">
    <div class="metadata-grid">
      <ng-container *ngFor="let data of sessionMetadata">
        <div class="meta-grid-key">{{ data.key }}</div>
        <div class="meta-grid-value">{{ data.value }}</div>
      </ng-container>
    </div>
  </div>
}
